import { createSelector } from "@ngrx/store";

import { HomeFeatureState } from "../state";

import { SBPopularCategoriesState } from "./sb-popular-categories.model";

export namespace SBPopularCategorySelector {
	const getSBPopularCategory = (state: HomeFeatureState) => state.homeFeature.sbPopularCategory;

	export const getAllPopularSBGamesAsQuickLinks = () =>
		createSelector(getSBPopularCategory, (state: SBPopularCategoriesState) => state.sbQuickLinks);
}
